import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Login from '../views/Login.vue'
import Inscription from '../views/Inscription.vue'
import InscriptionValidee from '../views/InscriptionValidee.vue'
import InscriptionDelete from '../views/InscriptionDelete.vue'
import User from '../views/admin/User.vue'
import Site from '../views/admin/Site.vue'
import Event from '../views/admin/Event.vue'
import EventManage from '../views/admin/components/event/EventManage.vue'
import EventSubscribedList from '../views/admin/components/event/EventSubscribedList.vue'
import EventWithPaymentSubscribedList from '../views/admin/components/event/EventWithPaymentSubscribedList.vue'

Vue.use(VueRouter)

export const InscriptionRouteName = 'Inscription';
export const InscriptionValideeRouteName = 'InscriptionValidee';
export const InscriptionDeleteRouteName = 'InscriptionAnnulation';
export const InscriptionUpdateRouteName = 'Mise à jour formulaire';
export const LoginRouteName = 'Login';

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/login',
    name: LoginRouteName,
    component: Login
  },
  {
    path: '/utilisateurs',
    name: 'Utilisateurs',
    component: User
  },
  {
    path: '/sites',
    name: 'Sites',
    component: Site
  },
  {
    path: '/evenements',
    name: 'Evenements',
    component: Event
  },
  {
    path: '/evenement/gestion',
    name: 'Gestion événément',
    component: EventManage
  },
  {
    path: '/evenement/gestion/inscrits',
    name: 'Gestion événément - liste inscrits',
    component: EventSubscribedList
  },
  {
    path: '/evenement/gestion/inscrits-detail',
    name: 'Gestion événément payant - liste inscrits',
    component: EventWithPaymentSubscribedList
  },
  {
    path: '/inscription',
    name: InscriptionRouteName,
    component: Inscription
  },
  {
    path: '/inscriptionValidee',
    name: InscriptionValideeRouteName,
    component: InscriptionValidee
  },
  {
    path: '/inscription-annulation',
    name: InscriptionDeleteRouteName,
    component: InscriptionDelete
  },
  {
    path: '/miseajour20210617',
    name: InscriptionUpdateRouteName,
    component: Inscription
  }
]

const router = new VueRouter({
  routes
})

export default router
